// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"132":"a82040943f3ba1ab","182":"73546ef6dadae6c0","198":"f08c29abba88df60","230":"4664fbf7cfbea978","416":"3e575af6b014f37d","478":"67a3f4ba5c407faa","686":"a8af77f6b9059b46","787":"ba945a2af2d488f2","799":"9e54956289b46845"}[chunkId] + ".js";
};